module.exports = __webpack_public_path__ + "img/Large-Bevel-Attachment-28.82288d7f.png";